<template>
  <div class="shimmer-tables-wrapper">
   
    <div class="shimmer-empty-state-wrapper" v-if="showEmptyText">

    <div v-if="error" class="shimmer-empty-state shimmer-error-state">
      <img
        class="shimmer-error-icon"
        src="@/assets/icons/error.gif"
        alt="Erreur"
      />
      <div class="shimmer-error-message">
        <strong>Oups&nbsp;!</strong> Vous n'êtes plus connectés à la plateforme.<br />
        <span class="shimmer-error-hint">
          Veuillez <strong>actualiser la page</strong> ou vous reconnecter.
        </span>
      </div>
    </div>


      <div v-else class="shimmer-empty-state"  >
        Aucun(e) <span class="shimmer-text-uppercase font-weight-bold">{{ state }}</span>
        <span class="shimmer-click-text text-primary" @click="$emit('show-all')">
          , cliquez ici pour voir toutes les tables
        </span>
      </div>
    </div>

    <div class="shimmer-tables-grid">
      <div
        v-for="(table, index) in count"
        :key="index"
        class="shimmer-table-card shimmer mb-3"
        :style="{
          cursor: 'pointer',
          border: '1px solid #ddd',
          background: '#f7f7f7',
          '--status-color': '#ddd'
        }"
      >
        <div class="shimmer-chair left"></div>
        <div class="shimmer-chair right"></div>

        <div class="shimmer-table-shape mb-2">
          <img
            class="shimmer-table-icon"
            src="@/assets/images/Spoon-fork-knife-icon.png"
            alt="Table Icon"
            width="60"
            height="60"
          />
        </div>

        <div class="shimmer-text-uppercase font-weight-bold">
          Table {{ table }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableShimmer",
  props: {
    count: { type: Number, default: 15 },
    state: { type: String, default: "" },
    showEmptyText: { type: Boolean, default: true },
    error: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.shimmer-tables-wrapper {
  text-align: center;
  padding: 30px 15px;
}

.shimmer-empty-state-wrapper {
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  text-align: center;
  width: 100%;
}

/* For small screens */
@media (max-width: 576px) {
  .shimmer-empty-state-wrapper {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
  }
}

.shimmer-empty-state {
  text-align: center;
  font-size: 1.1rem;
  color: #555;
}

.shimmer-click-text {
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s;
}


.shimmer-tables-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  justify-items: center;
  filter: blur(4px);
  pointer-events: none; 
  opacity: 0.8;
}

.shimmer-table-card {
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 10px;
  transition: all 0.3s ease;
  min-height: 130px;
  width: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}
.shimmer-table-card:hover {
  transform: translateY(-5px);
  background: #fdfdfd;
}

.shimmer-table-shape {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.08);
}

.shimmer-table-card::before,
.shimmer-table-card::after {
  content: "";
  position: absolute;
  width: 120px;
  height: 11px;
  background: #ccc;
  border-radius: 20%;
}
.shimmer-table-card::before {
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
}
.shimmer-table-card::after {
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
}

.shimmer-table-card .shimmer-chair {
  position: absolute;
  width: 11px;
  height: 120px;
  background: #ccc;
  border-radius: 20%;
}
.shimmer-table-card .shimmer-chair.left {
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
}
.shimmer-table-card .shimmer-chair.right {
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
}

.shimmer-table-card::before,
.shimmer-table-card::after,
.shimmer-table-card .shimmer-chair {
  background: var(--status-color);
}



.shimmer-error-icon {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-bottom: 10px;
}

.shimmer-error-message {
  font-size: 1rem;
  text-align: center;
  line-height: 1.4;
}

.shimmer-error-hint {
  display: block;
  font-size: 0.9rem;
  color: #dc3545;
  margin-top: 4px;
}

@keyframes shimmer-fade-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1550px) {
  .shimmer-tables-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 1250px) {
  .shimmer-tables-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 970px) {
  .shimmer-tables-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 650px) {
  .shimmer-tables-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
